// extracted by mini-css-extract-plugin
export default {"container":"tM-z","topReviewHeading":"uM-z","criticalReview":"vM-z","favorableReview":"wM-z","vsSeparator":"xM-z"};